/** Max length for document titles in forms / upload file names. */
export const MAX_DOCUMENT_TITLE_LENGTH = 200;

/**
 * Soft display width for titles in cards/tables: wrap to the next line after ~this many characters
 * so long titles do not stretch the layout.
 */
export const DOCUMENT_TITLE_LINE_CHARS = 60;

/**
 * Tailwind classes for title text that wraps around {@link DOCUMENT_TITLE_LINE_CHARS}
 * instead of overflowing or forcing a single truncated line.
 */
export const DOCUMENT_TITLE_WRAP_CLASS =
  'min-w-0 max-w-[60ch] break-words [overflow-wrap:anywhere] whitespace-normal';

/**
 * @param {unknown} title
 * @param {number} [maxLength]
 * @returns {string}
 */
export function clampDocumentTitle(title, maxLength = MAX_DOCUMENT_TITLE_LENGTH) {
  const value = String(title ?? '');
  if (value.length <= maxLength) return value;
  return value.slice(0, maxLength);
}

/**
 * Truncate a file name for upload while preserving the extension when possible.
 * @param {string} fileName
 * @param {number} [maxLength]
 * @returns {string}
 */
export function clampDocumentFileName(fileName, maxLength = MAX_DOCUMENT_TITLE_LENGTH) {
  const value = String(fileName ?? '');
  if (value.length <= maxLength) return value;

  const lastDot = value.lastIndexOf('.');
  if (lastDot <= 0) return value.slice(0, maxLength);

  const ext = value.slice(lastDot);
  if (ext.length >= maxLength) return value.slice(0, maxLength);

  return `${value.slice(0, maxLength - ext.length)}${ext}`;
}
